import React from "react";
import { css } from "@emotion/react";
import { borderColor } from "main/javascripts/styles/base/colorStyle";
import { ScrollableOptionPickerOptionList } from "./ScrollableOptionPickerOptionList";
import { OptionPickerOption } from "../../types/optionPickerOption";

export const enterDuration = 400;

interface IProps {
  options: OptionPickerOption[];
  onSelect(option: OptionPickerOption): void;
  hidePicker: any;
}

export const ScrollableOptionPicker: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { options, onSelect, hidePicker } = props;

  const onOptionSelect = (option: OptionPickerOption) => {
    onSelect(option);
    hidePicker();
  };

  return (
    <div css={blockStyle}>
      <div css={innerStyle}>
        <ScrollableOptionPickerOptionList
          onSelect={onOptionSelect}
          options={options}
        />
      </div>
    </div>
  );
};

const blockStyle = css`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  width: auto;
  background-color: white;
`;
const innerStyle = css`
  overflow-y: auto;
  height: 100%;
  border-top: 1px solid ${borderColor.secondaryLightColor};
`;
